<!--
* @description  参数1
* @fileName  bookingCancelled
* @author userName
* @date 2024-04-23 16:53:51
!-->
<template>
  <div id="bookingCancelled" class="bookingCancelled">
    <div class="bg-img">
      <div class="left">
        <img src="../../../../assets/img/client/感叹号@2x(1).png" width="24px" height="24px">
        <span>
          Booking cancelled
        </span>
      </div>
      <button class="by-button--primary" @click="toHome">Book Vew Shipment</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookingCancelled',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {}
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    toHome() {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.bookingCancelled {
		width: 1200px;
		height: 68px;
		background: #FFFFFF;
		border-radius: 8px;
		margin: 16px 0 22px 0;
		padding: 16px 0;

		.bg-img {
			width: 1168px;
			height: 68px;
			background: url('../../../../assets/img/client/booking/bg_xiadan@2x (1)(1).png');
			background-size: 1168px 68px;
			margin: 0 16px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.left {
				margin-left: 16px;
				display: flex;

				span {
					font-family: PingFangSC, PingFang SC;
					font-weight: 600;
					font-size: 18px;
					color: #333333;
					line-height: 25px;
					text-align: left;
					margin-left: 8px;
				}
			}

			button {
				margin-right: 16px;
				width: 160px;
				height: 32px;
				border-radius: 4px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #FFFFFF;
				line-height: 22px;
				text-align: center;
			}
		}
	}
</style>
